import { Box, Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { AttachmentIcon } from 'assets/icons';
import { generatePresignedUrl } from 'components/pages/container-category/container-category.fetcher';
import { t } from 'i18next';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'reducer/rootReducer';
import { ALERT_TYPE, GENERATE_PRESIGNED_URL_TYPE, TKeys } from 'utils/enums';
import { AppDialogTitle } from './dialog/dialog-title';
import { MAX_FILE_SIZE } from 'utils/constants';

const AppImagesField = (props: IAppImagesFieldProps) => {
    const { images, maxImage, onClose, open } = props;
    const dispatch = useDispatch();
    const [imagePreviewUrl, setImagePreviewUrl] = React.useState<string[]>([]);
    const [imagesCallback, setImagesCallback] = React.useState<(string | File)[]>([]);

    useEffect(() => {
        setImagesCallback(images);
        // eslint-disable-next-line  react-hooks/exhaustive-deps
    }, []);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                dispatch(
                    showAlert({
                        status: true,
                        message: t(TKeys.MSE00015),
                        type: ALERT_TYPE.ERROR,
                    }),
                );
                event.target.value = '';
                return;
            }

            setImagePreviewUrl([...imagePreviewUrl, URL.createObjectURL(file)].filter(Boolean));
            setImagesCallback([...imagesCallback, file].filter(Boolean));
        }
    };

    const handleRemoveImage = (index: number) => {
        const _imagePreviewUrl = imagePreviewUrl.filter((_, _index) => _index !== index);
        const _imagesCallback = imagesCallback.filter((_, _index) => _index !== index);
        setImagePreviewUrl(_imagePreviewUrl);
        setImagesCallback(_imagesCallback);
    };

    useEffect(() => {
        const fetchUrls = async () => {
            if (images.length === 0) return;

            const urls = await Promise.all(
                images.map(async (img) => {
                    if (typeof img === 'string') {
                        const res = await generatePresignedUrl({
                            file_path: img,
                            operation: GENERATE_PRESIGNED_URL_TYPE.DOWNLOAD,
                        });

                        return res.success ? res.data.data.presignedUrl : '';
                    } else {
                        return URL.createObjectURL(img);
                    }
                }),
            );

            setImagePreviewUrl(urls);
        };

        fetchUrls();
    }, [images]);

    return (
        <Dialog maxWidth="md" open={open} onClose={() => onClose(imagesCallback)}>
            {/* TODO */}
            <AppDialogTitle title={t(TKeys.LBL060006)} />
            <DialogContent>
                <Box sx={{ flexDirection: 'row', display: 'flex', paddingY: '16px' }}>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        minWidth={750}
                        width="100%">
                        <>
                            <label
                                htmlFor="image-upload"
                                style={{
                                    cursor: 'pointer',
                                    pointerEvents:
                                        imagePreviewUrl.length >= maxImage ? 'none' : 'auto',
                                }}>
                                <AttachmentIcon />
                            </label>

                            <input
                                id="image-upload"
                                type="file"
                                accept=".jpg, .jpeg, .png"
                                hidden
                                onChange={(e) => {
                                    handleFileChange(e);
                                    e.target.value = '';
                                }}
                            />
                        </>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                overflowX: 'auto',
                                width: '100%',
                                padding: 1,
                                gap: 1.5,
                            }}>
                            {imagePreviewUrl.map((img, index) => (
                                <Box
                                    key={img + index}
                                    sx={{
                                        position: 'relative',
                                        width: 300,
                                        height: 170,
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                    }}>
                                    <Box
                                        onClick={() => handleRemoveImage(index)}
                                        sx={{
                                            position: 'absolute',
                                            top: 8,
                                            right: 8,
                                            width: 32,
                                            height: 32,
                                            borderRadius: '8px',
                                            backgroundColor: '#828282',
                                            color: '#fff',
                                            fontWeight: 'bold',
                                            fontSize: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            zIndex: 1,
                                        }}>
                                        ×
                                    </Box>

                                    <Box
                                        component="img"
                                        src={img}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            display: 'block',
                                        }}
                                    />
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(imagesCallback)} aria-label='Close'>{t(TKeys.BTN000016)}</Button>
            </DialogActions>
        </Dialog>
    );
};

export { AppImagesField };
